<template>
  <div>
    <el-button :style="{background:color,borderColor:color}" icon="el-icon-upload" size="mini" type="primary" @click=" dialogVisible=true">
      视频上传
    </el-button>
    <el-dialog :visible.sync="dialogVisible" width="460px" :modal="false" title="视频上传">
      <el-upload
        ref="singleUploadFile"
        :action="uploadFile"
        accept=".mp4,.webm,.ogg,.avi,.mov,.3gp"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-success="successMultiFile"
        :on-error="errorMultiFile"
        :limit="2"
        :file-list="fList">
        <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
        <span slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-left: 10px">支持.mp4  .webm  .ogg  .avi  .mov  .3gp格式</span>
      </el-upload>
      <br>
      <div style="width: 100%;text-align: right">
        <el-button type="primary" size="small" @click="handleSubmit">
          确认
        </el-button>
        <el-button @click="dialogVisible = false" size="small">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'

export default {
  name: 'EditorVideoUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data() {
    return {
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      dialogVisible: false,
      fList: []
    }
  },
  methods: {
    handleRemove(file, fileList) {
      this.fList = []
    },
    errorMultiFile() {
      this.$message({
        type: 'error',
        message: '视频上传失败，请稍后重试'
      })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name } ？`)
    },
    successMultiFile(response, file, fileList) {
      this.fList = []
      if (response.success) {
        this.fList.push(file)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    handleSubmit() {
      if (this.fList.length <= 0) {
        this.$message({
          type: 'error',
          message: '请上传视频'
        })
        return
      }
      const arr = this.fList[0].response.data
      this.$emit('successVideo', arr)
      this.fList = []
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  deep .el-upload--picture-card {
    width: 100%;
  }
}
</style>
